import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { ReturnUrlService, UserSessionPersistenceService } from "@core/services";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private userSessionPersistenceService: UserSessionPersistenceService,
        private redirectUrlService: ReturnUrlService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.userSessionPersistenceService.getUserSession()) {
            return true;
        }

        this.redirectUrlService.set(state.url);

        this.router.navigate(['/auth/login'], {
            queryParams: { returnUrl: state.url },
        });
        return false;
    }
}
